export const paths = [{ "tag": "path", "att": { "d": "M14 14h-4v-2h4v2z" } }, { "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M21 4H3v6h1v10h16V10h1V4zm-3 6H6v8h12v-8zm1-2V6H5v2h14z" } }];
export const iconName = 'archive-box';
export const archiveBox = { iconName, paths };
export default paths;
